.c-label {

    display: inline-flex;

    align-items: center;

    justify-content: center;

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.25rem;

    padding-bottom: 0.25rem;

    border-radius: 0.375rem;

    --tw-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);

    --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

    font-weight: 500;

    line-height: 1 !important;

    --tw-border-opacity: 1;

    border-color: rgb(161 161 170 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(113 113 122 / var(--tw-text-opacity, 1));

    cursor: default
}

  .c-label[data-tooltip]:not([data-tooltip=""]) {

    cursor: help
}

  .c-label--positive,
  .c-label--green {

    --tw-bg-opacity: 1;

    background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(21 128 61 / var(--tw-text-opacity, 1))
}

  .c-label--orange {

    --tw-bg-opacity: 1;

    background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(194 65 12 / var(--tw-text-opacity, 1))
}

  .c-label--yellow {

    --tw-bg-opacity: 1;

    background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(161 98 7 / var(--tw-text-opacity, 1))
}

  .c-label--blue {

    --tw-bg-opacity: 1;

    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(29 78 216 / var(--tw-text-opacity, 1))
}

  .c-label--purple {

    --tw-bg-opacity: 1;

    background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(109 40 217 / var(--tw-text-opacity, 1))
}

  .c-label--negative,
  .c-label--red {

    --tw-bg-opacity: 1;

    background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(185 28 28 / var(--tw-text-opacity, 1))
}

/*# sourceMappingURL=data:application/json;base64,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 */